import { isNullOrUndefined } from "util";

export function initializePasswordToggle() {
    var showToggles: HTMLCollectionOf<Element> = document.getElementsByClassName('password-toggle-show');
    var hideToggles: HTMLCollectionOf<Element> = document.getElementsByClassName('password-toggle-hide');

    [].forEach.call(showToggles, showToggle => { showToggle.addEventListener('click', function (e) { handleShowClick(e) }) });
    [].forEach.call(hideToggles, hideToggle => { hideToggle.addEventListener('click', function (e) { handleHideClick(e) }) });
}

function handleShowClick(e) {
    var targetElement: HTMLElement = e.currentTarget;
    var nextElement: HTMLElement = targetElement.nextElementSibling as HTMLElement;
    var inputElement: HTMLInputElement = (targetElement.parentNode.parentNode as HTMLElement).getElementsByTagName('input')[0]; 

    if (!isNullOrUndefined(inputElement)) {
        toggleShowElements(targetElement, nextElement);
        showPassword(inputElement);
    }
}

function handleHideClick(e) {
    var targetElement: HTMLElement = e.currentTarget;
    var previousElement: HTMLElement = targetElement.previousElementSibling as HTMLElement;
    var inputElement: HTMLInputElement = (targetElement.parentNode.parentNode as HTMLElement).getElementsByTagName('input')[0]; 

    if (!isNullOrUndefined(inputElement)) {
        toggleShowElements(targetElement, previousElement);
        hidePassword(inputElement);
    }
}

function showPassword(inputElement: HTMLInputElement) {
    inputElement.type = 'text';
}

function hidePassword(inputElement: HTMLInputElement) {
    inputElement.type = 'password';
}

function toggleShowElements(targetElement, siblingElement) {
    targetElement.style.display = "none";
    siblingElement.style.display = "block";
}

